import { render, staticRenderFns } from "./FaviconCard.vue?vue&type=template&id=5032ab22&"
import script from "./FaviconCard.vue?vue&type=script&lang=js&"
export * from "./FaviconCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports